import { Event, TrackEntry } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { BitmapText } from "pixi.js";
import { getSpineSymbol } from "../../config/getSymbol";
import { isSuperQuickBtnOnGlobal, RespinIndex } from "../../config/GlobalVariableConfig";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { DisplayComponent } from "../../core/displays/DisplayComponent";
import { EventConstants } from "../../gameClientEvents/EventConstants";
import { GameConstants } from "../../gameClientEvents/GameConstants";
import { GameEvents } from "../../gameClientEvents/GameEvents";
import { ReelObject, reelSpinEmitter, SymbolObject } from "../../reels/ReelInit";
import { IFeatureData, IShutterFeatureData, RespinObject, spinData } from "../../server/getServerResposesFun";
import { checkIsBigWin, wait } from "../../utils";
import { ParallelTask, Task } from "../../utils/ParallelTask";
import { SequentialTask } from "../../utils/SequentialTask";
import { ReelComponent } from "../reels/ReelsComponent";
import { WinMeterComponent } from "../winmeters/WinMeterComponent";

let soundTimescale = isSuperQuickBtnOnGlobal ? 2 : 1;

export class WindMillComonent extends AbstractDisplayComponent {
  private featureData: IFeatureData;
  private shutterTypeDisplayDurationinMS: number = 50;
  private delayBetweenRewardsinMS: number = 150;
  private waitAfterFeatureDuration: number = 1000;
  private delayBetweenCollectinMS: number = 50;
  private delayBetweenShutterActions: number = 200;
  private delayBetweenSymbolReveal: number = 200;
  private triggerPosX: number;
  private triggerPosY: number;


  public override init() {

    reelSpinEmitter.on(EventConstants.SPIN_STEP_DONE, this.resetMultipliers, this);
    super.init();
  }

  public override destroy() {
    reelSpinEmitter.off(EventConstants.SPIN_STEP_DONE, this.resetMultipliers, this);
    super.destroy();
  }

  public startWindMillFeature(callback: () => void): Promise<any> {
    const data: RespinObject = spinData.respins[RespinIndex.value];
    this.featureData = data?.featureData;

    if (!this.featureData) {
      console.warn("WindMill No featureData found at index", RespinIndex.value);
      callback();
      return Promise.resolve();
    }

    let seq = new SequentialTask([
      () => wait(1000),
      () => this.tintSymbols(),
      () => this.animateShutterTrigger(),
      () => this.revealWindMills(),
      () => this.revealSymbols(),
      () => this.triggerShutters(),
      () => wait(this.waitAfterFeatureDuration),
      () => this.collectAll(),
      () => this.displayTotalWins(),
      () => this.resetFrameInFs(),
      () => {
        callback();
        return Promise.resolve();
      }
    ]);
    return seq.execute();

  }

  private tintSymbols() {
    let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;

    allReelArray.forEach((reelObj) => {
      reelObj.symbols.forEach((symbol) => {
        if (symbol.id !== GameConstants.WINDMILL_SYMBOL_ID && symbol.view.visible) {
          symbol.view.tint = 0x555555;
        }
      });
    });
  }

  private animateShutterTrigger() {
    let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
    let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
    const promises: Promise<void>[] = [];
    allReelArray.forEach((reelObj) => {
      reelObj.symbols.forEach((symbol) => {
        if (symbol.id === GameConstants.WINDMILL_SYMBOL_ID && symbol.view.visible) {
          this.triggerPosX = reelObj.reelIndex;
          this.triggerPosY = symbol.symbolIndex;
          promises.push(new Promise<void>((resolve) => {
            let listener = {
              complete: () => {
                symbol.symbol.state.removeListener(listener);
                symbol.symbol.state.setAnimation(0, "idle", true);
                resolve();
              }
            };

            symbol.symbol.state.addListener(listener);
            symbol.symbol.state.timeScale = timeScale;
            symbol.symbol.state.setAnimation(0, "active", false);
            sound.play('windmill_trigger', { volume: 1, speed: soundTimescale });

            // wait(500).then(() => {
            //   sound.play('shutter_opening', { volume: 1, speed: soundTimescale });
            // });
          }));
        }
      });
    });
    return Promise.all(promises);
  }

  private revealWindMills() {
    const data: RespinObject = spinData.respins[RespinIndex.value];
    this.featureData = data.featureData;
    // let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
    let arr: Task<any>[] = [];

    if (this.featureData) {
      let symbolsList = this.featureData.revealedSymbols;
      symbolsList.forEach(symbol => {
        if (symbol[0] === this.triggerPosX && symbol[1] === this.triggerPosY) {
          console.log("trigger symbol found ");
        } else {
          let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
          let sym: SymbolObject = this.swapSymbol(allReelArray[symbol[0]], symbol[1], false);
          arr.push(() => new Promise<void>((resolve) => {
            let listener = {
              complete: () => {
                resolve();
                sym.symbol.state.removeListener(listener);
                sym.symbol.state.setAnimation(0, "idle", true);
              }
            };

            sym.symbol.state.addListener(listener);
            // sym.symbol.state.timeScale = timeScale;
            sym.symbol.state.setAnimation(0, "appear", false);
            sym.symbol.state.apply(sym.symbol.skeleton);
            sym.view.visible = true;
          }));
          sound.play('windmill_spread', { volume: 0.5, speed: soundTimescale });
        }

        DisplayComponent.get(WinMeterComponent).getInstance().setupMeter(symbol[0] + "_" + symbol[1]);
      });
    }

    let pr = new ParallelTask(arr);
    return pr.execute({ stagger: 50 });
  }

  private swapSymbol(reelObj: ReelObject, symbolId: number, visibility: boolean = true, newSymbolId: number = GameConstants.WINDMILL_SYMBOL_ID): SymbolObject {
    const symbol = reelObj.symbols[symbolId];

    if (symbol) {
      symbol.symbol.destroy();
      const newSym = getSpineSymbol(newSymbolId);
      symbol.view.addChildAt(newSym, 0);
      symbol.id = newSymbolId;
      symbol.symbol = newSym;
      symbol.view.visible = visibility;
      symbol.view.tint = 0xffffff;
      symbol.view.alpha = 1;
      symbol.symbolIndex = symbolId;
      if (newSymbolId === GameConstants.SHUTTER_SYMBOL_ID) {
        symbol.symbol.state.setAnimation(0, "idle", true);
      }
    }

    return symbol;
  }

  private async revealSymbols() {
    let arr: Task<any>[] = [];

    if (this.featureData) {
      const { revealedSymbols, revealedMultiplierSymPos, revealedShutterSymPos } = this.featureData;

      const findPresentIn = (coord: number[], list: number[][]): number[] | undefined => {
        return list.find(item => {
          return item[0] === coord[0] && item[1] === coord[1];
        });
      };


      revealedSymbols.forEach((symbol) => {
        const matchMultiplier = findPresentIn(symbol, revealedMultiplierSymPos);
        const matchShutter = findPresentIn(symbol, revealedShutterSymPos);


        if (matchMultiplier) {
          this.revealMultiplierSym(symbol, arr);
        } else if (matchShutter) {
          this.revealShutterSym(symbol, arr);
        }
        arr.push(() => wait(this.delayBetweenRewardsinMS));
      });

    }

    let seq = new ParallelTask(arr);
    await seq.execute({ stagger: this.delayBetweenSymbolReveal, waitStrategy: 'all' });
  }

  private revealMultiplierSym(symbol: number[], arr: Task<any>[]) {
    let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
    let reelObj = allReelArray[symbol[0]];
    let symbolId = symbol[1];
    let multiplier = this.featureData.revealedMultipliers[symbol[0]][symbol[1]];
    console.log("mult " + multiplier);

    const sym = reelObj.symbols[symbolId];
    let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

    arr.push(() => new Promise<void>((resolve) => {
      let listener = {
        event: (_entry: TrackEntry, event: Event) => {
          if (event.data.name === "multiplier") {
            DisplayComponent.get(WinMeterComponent).getInstance().revealMultiplier(symbol[0] + "_" + symbol[1], multiplier, sym.symbol, sym.id);
            sound.play('windmill_reveal_to_plateandshutter', { volume: 1, speed: soundTimescale });
          }
        },
        complete: () => {
          resolve();
          sym.symbol.state.removeListener(listener);
        }
      };

      sym.symbol.state.addListener(listener);
      sym.symbol.state.timeScale = timeScale;
      sym.symbol.state.setAnimation(0, "reveal_multiplier", false);
    }));
  }

  private revealShutterSym(symbol: number[], arr: Task<any>[]) {
    let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
    let reelObj = allReelArray[symbol[0]];
    let symbolId = symbol[1];

    const sym = reelObj.symbols[symbolId];
    let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

    arr.push(() => new Promise<void>((resolve) => {
      let listener = {
        complete: () => {
          sym.symbol.state.removeListener(listener);
          this.swapSymbol(allReelArray[symbol[0]], symbolId, true, GameConstants.SHUTTER_SYMBOL_ID);
          resolve();
        }
      };

      sym.symbol.state.addListener(listener);
      sym.symbol.state.timeScale = timeScale;
      sym.symbol.state.setAnimation(0, "reveal_shutter", false);
      sound.play('windmill_reveal_shutter', { volume: 1, speed: soundTimescale });

    }));
  }

  private getShutterDataByPosition(position: number[], shutterList: IShutterFeatureData[]): IShutterFeatureData | undefined {
    return shutterList.find(shutter => {
      const [targetRow, targetCol] = position;
      const [shutterRow, shutterCol] = shutter.shutterPosition[0];

      return targetRow === shutterRow && targetCol === shutterCol;
    });
  }

  private triggerShutters() {
    let arr: Task<any>[] = [];
    this.featureData.revealedShutterSymPos.forEach(shutterPos => {
      let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
      let symbolId = shutterPos[1];

      this.showShutterReward(allReelArray[shutterPos[0]], symbolId, shutterPos, arr);
    });

    let seq = new SequentialTask(arr);
    return seq.execute();
  }

  private showShutterReward(reelObj: ReelObject, symbolId: number, pos: number[], arr: Task<any>[]) {
    let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
    const sym = reelObj.symbols[symbolId];
    let shutterData = this.getShutterDataByPosition(pos, this.featureData.shutterFeature);
    let anim: string;
    let isFirstTime: boolean = true;

    if (shutterData) {
      switch (shutterData.shutterType) {
        case "addShutter":
          anim = "add";
          break;
        case "collectShutter":
          anim = "collect";
          break;
        case "addCollectShutter":
          anim = "add_collect";
          break;
        case "collectAddShutter":
          anim = "collect_add";
          break;
        default:
          anim = "idle";
          break;
      }

      arr.push(() => new Promise<void>((resolve) => {
        let listener = {
          event: (_entry: TrackEntry, event: Event) => {
            if (event.data.name === "multiplier") {
              DisplayComponent.get(WinMeterComponent).getInstance().revealMultiplier(pos[0] + "_" + pos[1], shutterData.startCash, sym.symbol, sym.id);
              sound.play('multiplier_on_shutter', { volume: 1, speed: soundTimescale });
            }
          },
          complete: async () => {
            if (isFirstTime) {
              await wait(this.shutterTypeDisplayDurationinMS);
              sym.symbol.state.setAnimation(0, anim + "_multi", false);
              isFirstTime = false;
            } else {
              // await wait(this.shutterTypeDisplayDurationinMS);
              sym.symbol.state.removeListener(listener);
              this.triggerShutterType(shutterData, sym, resolve);
            }
          }
        };
        wait(500).then(() => {
          sound.play('shutter_opening', { volume: 1, speed: soundTimescale });
        });
        sym.symbol.state.addListener(listener);
        sym.symbol.state.timeScale = timeScale;
        sym.symbol.state.setAnimation(0, anim, false);
      }));
    }
  }

  private async triggerShutterType(shutterData: IShutterFeatureData, symbol: SymbolObject, callback: () => void) {
    let tasks: Task<any>[] = [];

    switch (shutterData.shutterType) {
      case "addShutter":
        tasks.push(() => this.addFeature(shutterData, symbol, false, false));
        break;
      case "collectShutter":
        tasks.push(() => this.collectFeature(shutterData, symbol, false, false));
        break;
      case "addCollectShutter":
        tasks.push(() => this.addFeature(shutterData, symbol, false, false));
        tasks.push(() => this.collectFeature(shutterData, symbol, false, false));
        break;
      case "collectAddShutter":
        tasks.push(() => this.collectFeature(shutterData, symbol, false, false));
        tasks.push(() => this.addFeature(shutterData, symbol, false, false));
        break;
    }

    const seq = new SequentialTask(tasks);
    await seq.execute();
    callback();
  }

  //@ts-ignore
  private async addFeature2(shutterData: IShutterFeatureData, symbol: SymbolObject) {
    const validTargets: { i: number, j: number }[] = [];
    for (let i = 0; i < shutterData.addedCash.length; i++) {
      for (let j = 0; j < shutterData.addedCash[i].length; j++) {
        if (shutterData.addedCash[i][j] > 0) {
          validTargets.push({ i, j });
        }
      }
    }

    if (validTargets.length === 0) return Promise.resolve();

    for (let k = 0; k < validTargets.length; k++) {
      const { i, j } = validTargets[k];
      const isLast = k === validTargets.length - 1;

      let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
      let reelObj = allReelArray[i];
      const targetSymbol = reelObj.symbols[j];
      const tMultiplier = targetSymbol.symbol.getSlotObject("multiplier") as BitmapText;
      const sMultiplier = symbol.symbol.getSlotObject("multiplier") as BitmapText;

      const sequenceTasks: Task<any>[] = [
        // Travel
        () => new Promise<void>((resolve) => {
          DisplayComponent.get(WinMeterComponent).getInstance()
            .addMultiplierTravelAnimation_Add(sMultiplier, tMultiplier, resolve);
        }),
        // Impact
        () => new Promise<void>((resolve) => {
          let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
          let listener = {
            complete: () => {
              targetSymbol.symbol.state.removeListener(listener);
              resolve();
            }
          };
          tMultiplier.text = shutterData.addedCash[i][j] + "x";
          // fitTextToWidth(tMultiplier, { maxWidth: 172 });
          targetSymbol.symbol.state.addListener(listener);
          targetSymbol.symbol.state.timeScale = timeScale;
          targetSymbol.symbol.state.setAnimation(0, "multiplier_impact", false);
        })
      ];

      const seq = new SequentialTask(sequenceTasks);
      const execution = seq.execute();

      if (isLast) {

        await execution;
      } else {

        await wait(this.delayBetweenShutterActions);
      }
    }
  }

  //@ts-ignore
  private async collectFeature2(shutterData: IShutterFeatureData, symbol: SymbolObject) {
    let shutterPosCol = shutterData.shutterPosition[0][0];
    let shutterPosRow = shutterData.shutterPosition[0][1];

    let tMultiplier: BitmapText;
    try {
      tMultiplier = symbol.symbol.getSlotObject("multiplier") as BitmapText;
    } catch (e) { return Promise.resolve(); }


    const validSources = this.featureData.revealedSymbols.filter(([reelIndx, symbolIndx]) => {
      return !(reelIndx === shutterPosCol && symbolIndx === shutterPosRow);
    });

    if (validSources.length > 0) {

      for (let k = 0; k < validSources.length; k++) {
        const [reelIndx, symbolIndx] = validSources[k];
        const isLast = k === validSources.length - 1;

        let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
        let srcSymbol = allReelArray[reelIndx].symbols[symbolIndx];
        let sMultiplier: BitmapText;

        try {
          sMultiplier = srcSymbol.symbol.getSlotObject("multiplier") as BitmapText;
        } catch (e) { continue; }

        // travel
        const travelPromise = new Promise<void>((resolve) => {
          DisplayComponent.get(WinMeterComponent).getInstance()
            .addMultiplierTravelAnimation_Collect(sMultiplier, tMultiplier, resolve);
        });

        if (isLast) {

          await travelPromise;
        } else {

          await wait(this.delayBetweenShutterActions);
        }
      }

      // impact
      await new Promise<void>((resolve) => {
        let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        let listener = {
          complete: () => {
            symbol.symbol.state.removeListener(listener);
            resolve();
          }
        };
        tMultiplier.text = shutterData.collectedCash + "x";
        // fitTextToWidth(tMultiplier, { maxWidth: 172 });
        symbol.symbol.state.clearListeners();
        symbol.symbol.state.addListener(listener);
        symbol.symbol.state.timeScale = timeScale;
        symbol.symbol.state.setAnimation(0, "multiplier_impact", false);
      });
    }
    return Promise.resolve();
  }

  //@ts-ignore
  private async addFeature(shutterData: IShutterFeatureData, symbol: SymbolObject, playIn: boolean = false, playOut: boolean = false) {
    let tasks: Task<any>[] = [];

    for (let i = 0; i < shutterData.addedCash.length; i++) {
      for (let j = 0; j < shutterData.addedCash[i].length; j++) {
        if (shutterData.shutterPosition[0][0] === i && shutterData.shutterPosition[0][1] === j) {
          continue;
        }
        if (shutterData.addedCash[i][j] > 0) {
          if (playIn) {
            symbol.symbol.state.setAnimation(0, "add_in", false);
          }

          const allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
          const targetSymbol = allReelArray[i].symbols[j];
          let tMultiplier: BitmapText;//= targetSymbol.symbol.getSlotObject("multiplier") as BitmapText;
          const sMultiplier = symbol.symbol.getSlotObject("multiplier") as BitmapText;
          try {
            tMultiplier = targetSymbol.symbol.getSlotObject("multiplier") as BitmapText;
          } catch (e) {
            continue;
          }

          if (!tMultiplier) continue;

          tasks.push(async () => {
            // 1. Travel
            await new Promise<void>(res =>
              DisplayComponent.get(WinMeterComponent).getInstance()
                .addMultiplierTravelAnimation_Collect(sMultiplier, tMultiplier, res)
            );
            // 2. Impact
            await new Promise<void>(res => {
              let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
              let listener = {
                complete: () => {
                  targetSymbol.symbol.state.removeListener(listener);
                  res();
                }
              };
              tMultiplier.text = shutterData.addedCash[i][j] + "x";
              // fitTextToWidth(tMultiplier, { maxWidth: 172 });
              targetSymbol.symbol.state.addListener(listener);
              targetSymbol.symbol.state.timeScale = timeScale;
              targetSymbol.symbol.state.setAnimation(0, "multiplier_impact", false);
              sound.play('multiplier_on_plates', { volume: 1, speed: soundTimescale });
            });
          });
        }
      }
    }

    if (tasks.length === 0) return;

    const masterTask = new ParallelTask(tasks);
    await masterTask.execute({ stagger: this.delayBetweenShutterActions, waitStrategy: 'last' });
    if (playOut)
      return await this.playInOut(symbol, "add_out");
    else
      return new Promise<void>((resolve) => resolve());
  }

  //@ts-ignore
  private async collectFeature(shutterData: IShutterFeatureData, symbol: SymbolObject, playIn: boolean = false, playOut: boolean = false) {
    let travelTasks: Task<any>[] = [];
    let shutterPosCol = shutterData.shutterPosition[0][0];
    let shutterPosRow = shutterData.shutterPosition[0][1];

    const tMultiplier = symbol.symbol.getSlotObject("multiplier") as BitmapText;
    let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

    if (playIn) {
      symbol.symbol.state.timeScale = timeScale;
      symbol.symbol.state.setAnimation(0, "collect_in", false);
    }

    for (let i = 0; i < this.featureData.revealedSymbols.length; i++) {
      let [reelIndx, symbolIndx] = this.featureData.revealedSymbols[i];
      if (reelIndx === shutterPosCol && symbolIndx === shutterPosRow) continue;

      const srcSymbol = DisplayComponent.get(ReelComponent).getInstance().allReelArray[reelIndx].symbols[symbolIndx];
      let sMultiplier: BitmapText | null = null;
      try {
        sMultiplier = srcSymbol.symbol.getSlotObject("multiplier") as BitmapText;
      } catch (e) { continue; }

      if (!sMultiplier) continue;

      travelTasks.push(async () => {
        await new Promise<void>(res =>
          DisplayComponent.get(WinMeterComponent).getInstance()
            .addMultiplierTravelAnimation_Collect(sMultiplier, tMultiplier, res)
        );

        tMultiplier.text = shutterData.collectedCash + "x";
        // fitTextToWidth(tMultiplier, { maxWidth: 172 });

        symbol.symbol.state.timeScale = timeScale;
        symbol.symbol.state.setAnimation(0, "multiplier_impact", false);
        sound.play('multiplier_on_plates', { volume: 1, speed: soundTimescale });
      });
    }

    if (travelTasks.length > 0) {
      const masterTravel = new ParallelTask(travelTasks);
      await masterTravel.execute({ stagger: this.delayBetweenShutterActions, waitStrategy: 'last' });
      await new Promise<void>((resolve) => {
        let listener = {
          complete: () => {
            symbol.symbol.state.removeListener(listener);
            resolve();
          }
        };
        symbol.symbol.state.addListener(listener);
        symbol.symbol.state.timeScale = timeScale;
        symbol.symbol.state.setAnimation(0, "multiplier_impact", false);
        sound.play('multiplier_on_plates', { volume: 1, speed: soundTimescale });
      });
    }

    if (playOut) {
      await this.playInOut(symbol, "collect_out");
    }
    return Promise.resolve();
  }

  private async playInOut(symbol: SymbolObject, anim: string) {
    let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
    return new Promise<void>((resolve) => {
      let listener = {
        complete: () => {
          symbol.symbol.state.removeListener(listener);
          resolve();
        }
      };

      symbol.symbol.state.addListener(listener);
      symbol.symbol.state.timeScale = timeScale;
      symbol.symbol.state.setAnimation(0, anim, false);
    })

  }

  //@ts-ignore
  private addFeature_seq(shutterData: IShutterFeatureData, symbol: SymbolObject) {
    let tasks: Task<any>[] = [];

    for (let i = 0; i < shutterData.addedCash.length; i++) {
      for (let j = 0; j < shutterData.addedCash[i].length; j++) {
        if (shutterData.addedCash[i][j] > 0) {

          let sequenceForThisSymbol: Task<any>[] = [];

          let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
          let reelObj = allReelArray[i];
          const targetSymbol = reelObj.symbols[j];
          const tMultiplier = targetSymbol.symbol.getSlotObject("multiplier") as BitmapText;
          const sMultiplier = symbol.symbol.getSlotObject("multiplier") as BitmapText;

          //Travel Animation
          sequenceForThisSymbol.push(() => new Promise<void>((resolve) => {
            DisplayComponent.get(WinMeterComponent).getInstance()
              .addMultiplierTravelAnimation_Add(sMultiplier, tMultiplier, resolve);
          }));

          //Impact Animation
          sequenceForThisSymbol.push(() => new Promise<void>((resolve) => {
            let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            let listener = {
              complete: () => {
                targetSymbol.symbol.state.removeListener(listener);
                resolve();
              }
            };

            tMultiplier.text = shutterData.addedCash[i][j] + "x";
            // fitTextToWidth(tMultiplier, { maxWidth: 172 });
            targetSymbol.symbol.state.addListener(listener);
            targetSymbol.symbol.state.timeScale = timeScale;
            targetSymbol.symbol.state.setAnimation(0, "multiplier_impact", false);
          }));

          const seq = new SequentialTask(sequenceForThisSymbol);

          tasks.push(() => seq.execute());
        }
      }
    }

    let masterTask = new SequentialTask(tasks);
    return masterTask.execute();
  }

  //@ts-ignore
  private async collectFeature_seq(shutterData: IShutterFeatureData, symbol: SymbolObject) {
    let travelTasks: Task<any>[] = [];
    let shutterPosCol = shutterData.shutterPosition[0][0];
    let shutterPosRow = shutterData.shutterPosition[0][1];

    let tMultiplier: BitmapText;
    try {
      tMultiplier = symbol.symbol.getSlotObject("multiplier") as BitmapText;
    } catch (e) { return Promise.resolve(); }

    for (let i = 0; i < this.featureData.revealedSymbols.length; i++) {
      let [reelIndx, symbolIndx] = this.featureData.revealedSymbols[i];

      if (reelIndx === shutterPosCol && symbolIndx === shutterPosRow) continue;

      let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
      let srcSymbol = allReelArray[reelIndx].symbols[symbolIndx];

      let sMultiplier: BitmapText | null = null;
      try {
        sMultiplier = srcSymbol.symbol.getSlotObject("multiplier") as BitmapText;
      } catch (e) { continue; }

      if (!sMultiplier) continue;

      let sequenceForThisSymbol: Task<any>[] = [];

      sequenceForThisSymbol.push(() => new Promise<void>((resolve) => {
        DisplayComponent.get(WinMeterComponent).getInstance()
          .addMultiplierTravelAnimation_Collect(sMultiplier, tMultiplier, resolve);
      }));

      sequenceForThisSymbol.push(() => new Promise<void>((resolve) => {
        let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        let listener = {
          complete: () => {
            symbol.symbol.state.removeListener(listener);
            resolve();
          }
        };
        tMultiplier.text = shutterData.collectedCash + "x";
        // fitTextToWidth(tMultiplier, { maxWidth: 172 });
        symbol.symbol.state.clearListeners();
        symbol.symbol.state.addListener(listener);
        symbol.symbol.state.timeScale = timeScale;
        symbol.symbol.state.setAnimation(0, "multiplier_impact", false);
      }));

      const seq = new SequentialTask(sequenceForThisSymbol);

      travelTasks.push(() => seq.execute());
      travelTasks.push(() => wait(this.delayBetweenCollectinMS));
    }

    const masterTravel = new SequentialTask(travelTasks);
    return masterTravel.execute();
  }

  private collectAll() {
    let parallelTasks: Task<any>[] = [];
    let symbolsList = this.featureData.revealedSymbols;
    let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
    let reelObj = allReelArray[2];
    const targetSymbol = reelObj.symbols[2];
    const tPos = targetSymbol.symbol;

    let sMultiplierList: BitmapText[] = [];

    for (let i = 0; i < symbolsList.length; i++) {
      const symbol = symbolsList[i];
      let reelobj = allReelArray[symbol[0]];
      let sym = reelobj.symbols[symbol[1]];
      let sMultiplier: BitmapText | null = null;
      try {
        sMultiplier = sym.symbol.getSlotObject("multiplier") as BitmapText;
      } catch (e) { continue; }

      if (!sMultiplier) continue;

      sMultiplierList.push(sMultiplier);
    }

    sMultiplierList.push(DisplayComponent.get(ReelComponent).getInstance().accumWinText);

    //Travel Animation
    parallelTasks.push(() => new Promise<void>((resolve) => {
      DisplayComponent.get(WinMeterComponent).getInstance().collectAllMultipliersSpiral(sMultiplierList, tPos, resolve);
    }));

    let masterTask = new ParallelTask(parallelTasks);
    return masterTask.execute();
  }

  private displayTotalWins() {
    const data: RespinObject = spinData.respins[RespinIndex.value];
    if (!checkIsBigWin(data.accumulatedsWinAmount)) {
      let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
      let reelObj = allReelArray[2];
      const targetSymbol = reelObj.symbols[2];
      const tPos = targetSymbol.symbol;
      return new Promise<void>((resolve) => {
        DisplayComponent.get(WinMeterComponent).getInstance().showTotalWinMeter(tPos, data.accumulatedsWinAmount, resolve)
      });
    }

    return Promise.resolve();
  }

  private resetFrameInFs() {
    const respinType = spinData.respins[RespinIndex.value]?.type;
    if (respinType === "fs_windmill_reveal") {
      /* const nxtRespinType = spinData.respins[RespinIndex.value + 1]?.type;
       if (nxtRespinType !== "max_win_reached" && nxtRespinType !== "feature_exit") {
           DisplayComponent.get(WinMeterComponent).getInstance().resetMultipliers();
       }*/
      return new Promise<void>((res) => {
        res();
        GameEvents.emitter.emit(EventConstants.HIDE_FRAMES);
      });
    } else {
      return Promise.resolve();
    }
  }

  //@ts-ignore
  private resetSymbols() {
    let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;
    allReelArray.forEach((reelObj) => {
      reelObj.symbols.forEach((symbol) => {
        if (symbol.id === GameConstants.WINDMILL_SYMBOL_ID) {
          symbol.symbol.state.setAnimation(0, "idle", false);
          symbol.symbol.state.update(0);
          symbol.symbol.state.timeScale = 0;
        }
      })
    })
  }

  private resetMultipliers() {
    DisplayComponent.get(WinMeterComponent).getInstance().resetMultipliers();
  }
}
